/**
 * @typedef { object } BaseTheme
 * @property { string } textCopy
 * @property { string } background
 */

/**
 * @typedef { object } Theme
 * @extends BaseTheme
 * @property { string } icon
 * @property { string } iconHover
 * @property { string } iconDisabled
 * @property { string } iconPressed
 */

/**
 * 
 * @param {Theme} lightTheme 
 * @param {Theme} darkTheme 
 * @param {BaseTheme} sepiaTheme 
 * @param {BaseTheme} charcoalTheme 
 * @returns 
 */
export function createThemeButtonsPallette(lightTheme, darkTheme, _sepiaTheme, _charcoalTheme) {
  const sepiaTheme = Object.assign(
    { textCopy: lightTheme.text, background: lightTheme.background },
    _sepiaTheme
  );
  const charcoalTheme = Object.assign(
    { textCopy: darkTheme.text, background: darkTheme.background },
    _charcoalTheme
  );

  /**
   * Theme buttons pallette
   */
  function getThemeKeys(theme) {
    const {
      text: textCopy,
      background,
      iconDisabled,
      iconHover,
      iconPressed,
      icon
    } = theme;
    return {
      textCopy,
      background,
      iconDisabled,
      iconHover,
      iconPressed,
      icon
    };
  }

  return Object.freeze({
    light: getThemeKeys(lightTheme),
    dark: getThemeKeys(darkTheme),
    sepia: {
      textCopy: sepiaTheme.textCopy,
      background: sepiaTheme.background
    },
    charcoal: {
      textCopy: charcoalTheme.textCopy,
      background: charcoalTheme.background
    }
  });
}
